/* eslint-disable no-unused-vars */
import { ReactNode } from 'react'

import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { COLORS, SPACING, FORMAT } from 'utils'

import {
  CustomIntlCurrencyInput,
  InputStyles,
  InputLabelCustom
} from './styles'

interface InputProps extends InputStyles {
  control?: any
  errors?: any
  label?: string
  formValue?: string
  value?: string | number
  required?: boolean
  placeholder?: string
  inputIcon?: ReactNode
  onClickIcon?: () => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onKeyPress?: any
  endAdornment?: React.ReactNode
  type?: string
  name?: string
  disabled?: boolean
  maxLength?: number
  defaultValue?: string
  ref?: any
  onBlur?: (e: any) => void
  customError?: any
  style?: 'currency' | 'decimal' | 'percent'
}

const decimalConfig = {
  formats: {
    number: {
      BRL: {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'decimal'
      }
    }
  },
  locale: 'pt-BR'
}

const currencyConfig = {
  formats: {
    number: {
      BRL: {
        currency: 'BRL',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'currency'
      }
    }
  },
  locale: 'pt-BR'
}

const percentConfig = {
  formats: {
    number: {
      BRL: {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: 'decimal'
      }
    }
  },
  locale: 'pt-BR'
}

const getConfig = (style: 'currency' | 'decimal' | 'percent') => {
  if (style === 'currency') {
    return currencyConfig
  }

  if (style === 'decimal') {
    return decimalConfig
  }

  return percentConfig
}

const CurrencyInput: React.FC<InputProps> = ({
  customError,
  control,
  label,
  errors,
  required,
  placeholder,
  disabled = false,
  type,
  marginTop,
  value,
  onChange,
  onKeyPress,
  onBlur,
  marginBottom,
  marginLeft,
  marginRight,
  formValue,
  defaultValue,
  ref,
  style = 'currency',
  ...props
}) => {
  const hasError = (errors && errors[formValue]) || customError
  const error = hasError && errors ? errors[formValue] : customError
  const formatLabel = label?.charAt(0).toUpperCase() + label?.slice(1)

  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      <InputLabelCustom hasError={hasError}>
        {formatLabel || ''}
      </InputLabelCustom>
      {control ? (
        <Controller
          name={formValue}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomIntlCurrencyInput
              {...props}
              disabled={disabled}
              currency="BRL"
              config={getConfig(style)}
              onChange={(event, value) => {
                event.target.value = value
                onChange(event)
              }}
              type={type || 'text'}
              marginBottom={hasError && SPACING.spacing5}
              value={FORMAT.currency(value, style)}
              onKeyPress={onKeyPress}
              placeholder={placeholder}
              error={!!error}
              hasError={hasError}
              variant="standard"
              onBlur={onBlur}
              ref={ref}
            />
          )}
          rules={{ required }}
        />
      ) : (
        <CustomIntlCurrencyInput
          {...props}
          defaultValue={defaultValue}
          currency="BRL"
          name={formValue}
          config={getConfig(style)}
          onChange={(event, value) => {
            event.target.value = value
            onChange(event)
          }}
          disabled={disabled}
          type={type || 'text'}
          marginBottom={hasError && SPACING.spacing5}
          value={FORMAT.currency(value, style)}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          hasError={hasError}
          variant="standard"
          onBlur={onBlur}
          ref={ref}
        />
      )}

      {hasError && (
        <Span text={error?.message || 'Erro.'} color={COLORS.error} />
      )}
    </Col>
  )
}

export default CurrencyInput
